import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import SectionRibbon from './SectionRibbon';
import NewsCard from './NewsCard';

const NewsSection = () => {
  const { t } = useLanguage();

  const newsItems = [
    {
      title: 'Court Announces New Filing System',
      description: 'The High Court of Tanzania has implemented a new electronic filing system to streamline court processes and improve efficiency.',
      imageUrl: 'https://images.unsplash.com/photo-1589994965851-a8f479c573a9?w=395&h=258&fit=crop'
    },
    {
      title: 'Chief Justice Addresses Legal Forum',
      description: 'The Chief Justice delivered a keynote speech at the annual Legal Forum, highlighting the importance of modernizing court procedures.',
      imageUrl: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=395&h=258&fit=crop'
    },
    {
      title: 'New Court Guidelines Released',
      description: 'The High Court has released updated guidelines for court proceedings, incorporating feedback from legal practitioners.',
      imageUrl: 'https://images.unsplash.com/photo-1589578527966-fdac0f44566c?w=395&h=258&fit=crop'
    },
    {
      title: 'Judicial Training Program Launched',
      description: 'A comprehensive training program for judicial officers has been launched, focusing on emerging legal issues.',
      imageUrl: 'https://images.unsplash.com/photo-1589994965851-a8f479c573a9?w=395&h=258&fit=crop'
    }
  ];

  return (
    <div className="flex-1">
      <SectionRibbon title={t('news.title')} />
      <div className="flex flex-col items-center">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8 justify-items-center">
          {newsItems.map((item, index) => (
            <NewsCard
              key={index}
              index={index + 1}
              title={item.title}
              description={item.description}
              imageUrl={item.imageUrl}
            />
          ))}
        </div>
        <div className="mt-8 mb-4">
          <button 
            className="bg-[#0A1F87] text-white px-8 py-3 rounded-md hover:bg-[#0A1F87]/90 transition-colors duration-200 font-medium"
          >
            Explore Our News
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewsSection;